/* eslint-disable */
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import { Menu, Skeleton } from 'antd';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import css from './stylesSCSS.module.scss';

export const TabsRouting = props => {
  const navigate = useNavigate();

  const renderLabel = (item, key) => {
    if (item?.loading) {
      return (
        <Skeleton
          key={`tab_skeleton${key}`}
          className={css['tab-skeleton']}
          paragraph={false}
          loading={item.loading}
        ></Skeleton>
      );
    } else {
      return (
        <div
          className={classNames(css['tab-link'], { [css.maxOverflowScreen]: props.isProfile }, props.className || '')}
          key={`tab_routs${key}`}
          data-qa={item.dataQa}
        >
          {item.name}
          {item.total && (
            <span className={css.new}>
              <p className={css.count}>{item.total}</p>{' '}
              {item.name === props.t('recommended') && !props.isAnother && item.newValue !== 0 && (
                <div className={css.new__status} />
              )}
            </span>
          )}
        </div>
      );
    }
  };

  const items = props?.tabsList?.map((item, key) => {
    return {
      label: renderLabel(item, key),
      key: item.url,
    };
  });

  const onClick = e => {
    props.setPlacement(e.key);
    navigate(`${props.basePage}${e.key}`);
  };

  return (
    <div className={css.tab}>
      <div className={css['tab-link']}>
        <Menu
          className={css['tab-container']}
          onClick={onClick}
          selectedKeys={[props.placement]}
          mode='horizontal'
          items={items}
        />
      </div>
    </div>
  );
};

TabsRouting.propTypes = {
  basePage: PropTypes.string,
  domainCompany: PropTypes.object,
  isAnother: PropTypes.bool,
  newValue: PropTypes.func,
  tabsList: PropTypes.array,
  total: PropTypes.number,
  userId: PropTypes.number,
  isProfile: PropTypes.bool,
};

export default withTranslation('tabsRouting')(TabsRouting);
